import styled from '@emotion/styled';
import dynamic from 'next/dynamic';

const Trustpilot = dynamic(
  () => import('../TrustSeals').then(module => module.Trustpilot),
  { ssr: false },
);

type StageWrapperProps = {
  isErrorPage?: boolean;
};

const Wrapper = styled.div<StageWrapperProps>`
  position: relative;
  display: flex;
  height: ${({ isErrorPage }) => (isErrorPage && '203px') || '350px'};
  padding: ${({ theme }) => theme.spacing['50']};
  margin-top: ${({ isErrorPage }) => isErrorPage && '-1rem'};
  z-index: 10;
`;

const TrustpilotWidget = styled(Trustpilot)`
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
`;

export { Wrapper, TrustpilotWidget };
